import { api } from './client.js';

const root = '/admin/users';

export const usersApi = {
  list: (params) => api.get(root, { query: params }),
  get: (id) => api.get(`${root}/${id}`),
  create: (body) => api.post(root, body),
  update: (id, body) => api.patch(`${root}/${id}`, body),
  unlock: (id) => api.post(`${root}/${id}/unlock`),
  assignRole: (id, body) => api.put(`${root}/${id}/role`, body),
  resetPassword: (id, body) => api.put(`${root}/${id}/password`, body),
  remove: (id) => api.delete(`${root}/${id}`)
};
